export const build_version = 'BUILD_VERSION'
